/**
 * Created by yniran on 12/14/14.
 */
define(function (require) {
    "use strict";

    var LE = require("app"),
        CP_CONST = require("connection-const"),
        LEConfig = require("assets/config/le-env-conf"),
        BaseCollection = require("collections/BaseCollection"),
        ApiResources = require("assets/data/apiResources.json"),
        ChatContactModel = require("connection-models/chatTab/ChatContactModel"),
        ContactsAvailabilityCollection = {};

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {

        var logger = LEConnection.logger;

        ContactsAvailabilityCollection = BaseCollection.extend({
            //TE might not be needed anymore
            allAgentsOffline: false,
            resource: ApiResources.AppServer.Availability,  //https://base.liveperson.net/hc/5296924/?site=5296924&cmd=lpTagRepstateMulti&ag=1738048016,1738048019,1738047927,1738048018,1738047775,1738047683,1738048039,1738047933,1738048047,1738047973,1738048046,1738048036,1738048045,1738048031,1738047829,1738048033,1738048032,1738048021,1738048040,1738048015&c=1&sk=242,245&lpCallId=2
            model: ChatContactModel,
            initialize: function (options) { //passing skills and agents together isnt supported - should be just one type per collection instance
                this._setContactList(options);
                this._currentAppKey = options.appKey;
            },

            getContactType: function () {
                return this._contactType;
            },

            fetch: function (options) {
                this._setContactList(options);
                _.extend(options, {
                    headers: {
                        'Authorization': 'LivePerson appKey=' + this._currentAppKey,
                        'Accept': 'application/json'
                    }
                });
                return BaseCollection.prototype.fetch.call(this, options);
            },

            parse: function (resp) {
                var availabilityArray;

                if (resp && resp.hasOwnProperty("AvailabilityForSkills") && resp.AvailabilityForSkills.hasOwnProperty("skillAvailability")) {
                    availabilityArray = resp.AvailabilityForSkills.skillAvailability;
                    resp = availabilityArray.map(function (element) {
                        element.skillName = element.skill;
                        element.availability = element.isAvailable;
                        return _.pick(element, 'skillName', 'availability');
                    });

                    this.allAgentsOffline = availabilityArray.reduce(function (acc, element) {
                        return acc && !element.isAvailable;
                    }, true);

                } else {
                    logger.error("received an invalid response", "ContactsAvailabilityCollection",{response: resp});
                    logger.graph({name:"connection:ContactsAvailabilityCollection:parse:invalidResponse"});
                }

                return resp;
            },

            _setContactList: function (options) {

                if (options.contactType && options.ids) {

                    var urlIdsList = this._getAvailabilityUrlList(options.ids);

                    this._contactType = options.contactType;

                    if (options.contactType === CP_CONST.CONTACT_TYPE.GROUP) {
                        this.resource.skills_avail = urlIdsList;
                    }
                }
            },

            _getAvailabilityUrlList: function (list) {
                var res = "";
                //only add real Strings and skip undefined values if there are any
                if(_.isArray(list)){
                    _.each(list,function(element){
                        if(!_.isUndefined(element)){
                            res += "&skill=" + element;
                        }
                    });
                }

                return res;
            }
        });
    });

    return ContactsAvailabilityCollection;
});

